import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useAppSelector } from '../hooks';
export const ConfigDeviceRow = (props) => {
    const devicesMap = useAppSelector(state => state.definitions.devices);
    const device = devicesMap[props.id];
    if (!device) {
        return null;
    }
    let name;
    if (device.protocol.name == 'zigbee') {
        const url = '/config/zigbee/' + device.protocol.zigbee_node_id;
        name = _jsx(Link, { to: url, children: "Zigbee" });
    }
    else {
        name = device.protocol.name;
    }
    return (_jsxs("div", { className: "config-device-row", children: [_jsx("div", { children: device.id }), _jsx("div", { children: _jsx(Link, { to: '/config/device/' + device.id, children: device.title }) }), _jsx("div", { children: name })] }));
};
